module.exports = __webpack_public_path__ + "img/goal04.2dd59a42.png";